import type { JSX } from 'react';
import { ServiceCode } from '@common/enums';
import { findSingleProcessByServiceCode } from '@common/utils/processUtil';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';
import { ObesiQTrends } from './obesiQ/ObesiQTrends';
import { TotalWeightLoss } from './totalWeightLoss/TotalWeightLoss';

export function BariatricsMonitoring(): JSX.Element | null {
    const { processes } = usePatientEpisodeCategoryContext();
    const bariPostProcess = findSingleProcessByServiceCode(processes, ServiceCode.BariPost);

    if (!bariPostProcess) {
        return null;
    }

    return (
        <>
            <TotalWeightLoss process={bariPostProcess} />
            <ObesiQTrends process={bariPostProcess} />
        </>
    );
}
